export default "/_next/static/data/personalization-and-privacy.json-4b3a0b4436330ecde1ea209c03522193.json";